import type { AgentState } from "~/protocol";

// The top-bar status pill, derived from the agent state and what the feed shows.

export function pill(
  agent: AgentState,
  connected: boolean,
  filming: boolean,
  hasVideo: boolean,
): { label: string; busy: boolean } {
  if (!connected) return { label: "reconnecting…", busy: true };
  if (agent.status === "awaiting_user") return { label: "waiting for you", busy: true };
  if (agent.status === "running") {
    if (agent.active === "explorer") return { label: "exploring", busy: true };
    return { label: filming ? "filming" : "working", busy: true };
  }
  return { label: hasVideo ? "ready" : "idle", busy: false };
}
